import Index from './Drivers'
import IndexHeading from './IndexHeading'
import CreateHeading from './CreateHeading'
import EditHeading from './EditHeading'
import Form from './Form'

export default {
  Index,
  IndexHeading,
  CreateHeading,
  EditHeading,
  Form
}



// WEBPACK FOOTER //
// ./src/components/drivers/index.js